module.exports = __webpack_public_path__ + "benin.svg?4a79a54d682a2d03da1c486884f979c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/benin.svg
// module id = 110
// module chunks = 10